import { page as pageIndex } from "../../globals";
import { addChangesToHistory } from "./undo";
// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_DATA = "UPDATE_DATA";
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  updateData,
};

export function updateData(
  location,
  valueType,
  valueID,
  fieldValue,
  addToHistoryUndo,
  arrayIndex
) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_DATA,
      location,
      valueType,
      payload: {
        value: valueID,
        fieldValue: fieldValue,
        arrayIndex: arrayIndex,
      },
    });

    // temporary fix until determine how to get addToHistoryUndo to pass/bind.
    if (location.page == "SR" && location.field == "currentLegisProgress") {
      addToHistoryUndo = true;
    }

    if (addToHistoryUndo) {
      console.log(
        "New Update",
        location,
        valueType,
        valueID,
        fieldValue,
        arrayIndex
      );
      dispatch(
        addChangesToHistory(
          location,
          valueType,
          valueID,
          fieldValue,
          arrayIndex
        )
      );
    }
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
export const actionHandler = (state, action) => {
  const { page, field } = action.location;
  const { value, fieldValue, arrayIndex } = action.payload;
  switch (action.valueType) {
    case "array": {
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: fieldValue,
            },
          },
        },
      };
    }
    case "ch": {
      // mark single checkbox as checked
      let resultedSelectedArray;
      if (
        (field === "archivedSubjects" || field === "favorites") &&
        state.formDataValue[page][field].selected.includes("0")
      ) {
        resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue[page][field].selected, ...value].filter(
              (item) => item !== "0"
            )
          : [...state.formDataValue[page][field].selected, value].filter(
              (item) => item !== "0"
            );
      } else {
        resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue[page][field].selected, ...value]
          : [...state.formDataValue[page][field].selected, value];
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedSelectedArray,
            },
          },
        },
      };
    }
    case "ch_uncheck": {
      // uncheck single checkbox
      let resultedSelectedArray = state.formDataValue[page][field].selected;
      if (Array.isArray(value)) {
        value.forEach((item) => {
          resultedSelectedArray = resultedSelectedArray.filter(function (
            element
          ) {
            return element !== item;
          });
        });
      } else {
        const idIndex =
          state.formDataValue[page][field].selected.indexOf(value);
        resultedSelectedArray = [
          ...resultedSelectedArray.slice(0, idIndex),
          ...resultedSelectedArray.slice(idIndex + 1),
        ];
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedSelectedArray,
            },
          },
        },
      };
    }
    case "checkbox_selectall": {
      // check all archived years
      const renderData = state.renderData[page].groupNotes;
      let yearsArr = [];
      if (fieldValue === "ch") {
        const yLength = new Date().getFullYear() - 1;
        for (let i = yLength; i >= renderData.archiveStartYear; i--) {
          yearsArr.push(i.toString());
        }
        yearsArr.push("current", "all");
      } else {
        if (page === pageIndex.cmd) {
          const selectedItem = renderData.selectedReport.CriteriaJson;
          const searchParams = JSON.parse(selectedItem).SearchCriteria.filter(
            (item) => item.Name === "selectArchiveYear"
          );
          yearsArr =
            searchParams.length === 0
              ? ["current"]
              : searchParams[0].Values.map((item) => parseInt(item));
        } else {
          if (renderData.selectedReport) {
            const selectedItem = renderData.selectedReport.ReportCriteria;
            const searchParams = selectedItem.filter(
              (item) => item.CriteriaName === "archive"
            );
            yearsArr =
              searchParams.length === 0
                ? ["current"]
                : searchParams[0].CriteriaValue;
          } else {
            yearsArr = ["current"];
          }
        }
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: yearsArr,
            },
          },
        },
      };
    }
    case "ch_uncheckall": {
      // uncheck all checkboxes
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: [],
            },
          },
        },
      };
    }
    case "ch_one": {
      // leave only one checkbox from one block
      const resultedArr = fieldValue === "ch" ? [value] : [];
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedArr,
            },
          },
        },
      };
    }
    case "ch_selectall": {
      let resultedArray = state.formDataValue[page][field].selected;
      if (field !== "queryLine") {
        for (let i = 0; i < value.length; i++) {
          if (!resultedArray.includes(value[i])) {
            resultedArray = [...resultedArray, value[i]];
          }
        }
      } else {
        resultedArray = value;
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedArray,
            },
          },
        },
      };
    }
    case "ch_with_child": {
      // mark parent checkbox
      let resultedSelectedArray = state.formDataValue[page][field].selected;
      if (page === pageIndex.local || page === pageIndex.cmd) {
        if (!resultedSelectedArray.includes(value[0])) {
          for (let i = 0; i < value.length; i++) {
            if (!resultedSelectedArray.includes(value[i])) {
              resultedSelectedArray = [...resultedSelectedArray, value[i]];
            }
          }
        } else {
          for (let i = 0; i < value.length; i++) {
            resultedSelectedArray = resultedSelectedArray.filter(
              (item) => item !== value[i]
            );
          }
        }
      } else {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            resultedSelectedArray = resultedSelectedArray.filter(function (
              element
            ) {
              return element === item;
            });
          });
        }
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedSelectedArray,
            },
          },
        },
      };
    }
    case "children": {
      // mark child checkbox
      let resultedSelectedArray = state.formDataValue[page][field].selected;
      if (page === pageIndex.local) {
        if (resultedSelectedArray.includes(value.substring(0, 2))) {
          resultedSelectedArray = resultedSelectedArray.filter(
            (elem) => value.substring(0, 2) !== elem && value !== elem
          );
        } else if (!resultedSelectedArray.includes(value)) {
          resultedSelectedArray = [...resultedSelectedArray, value];
        } else {
          resultedSelectedArray = resultedSelectedArray.filter(
            (item) => item !== value
          );
        }
      } else if (page === pageIndex.cmd) {
        const localList = state.renderData[page].groupNotes.localityList;
        let stateNameToRemove = "";
        if (resultedSelectedArray.includes(value)) {
          localList.map((item) => {
            if (item.localityIds.includes(value)) {
              stateNameToRemove = item.id;
            }
          });
          resultedSelectedArray = resultedSelectedArray.filter(
            (elem) => value !== elem && elem !== stateNameToRemove
          );
        } else {
          resultedSelectedArray = [...resultedSelectedArray, value];
        }
      } else {
        resultedSelectedArray = Array.isArray(value)
          ? [...state.formDataValue[page][field].selected, ...value]
          : [...state.formDataValue[page][field].selected, value];
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedSelectedArray,
            },
          },
        },
      };
    }
    case "ch_uncheckall_gn": {
      const arrayValues = state.renderData[page].groupNotes.fieldOptions;
      let resultedSelectedArray = state.formDataValue[page][field].selected;
      const newArr = arrayValues[value].map((item) => item.id);
      newArr.forEach(function (item) {
        if (resultedSelectedArray.includes(item)) {
          resultedSelectedArray = resultedSelectedArray.filter(
            (elem) => elem !== item
          );
        } else return resultedSelectedArray;
      });
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedSelectedArray,
            },
          },
        },
      };
    }
    case "ch_hide-others": {
      // hide all other checkboxes
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              radio: {
                ...state.formDataValue[page][field].radio,
                [fieldValue]: value,
              },
            },
          },
        },
      };
    }
    case "checkbox-exclude-others": {
      // exclude all other checkboxes
      let resultedArray = state.formDataValue[page][field].selected;
      if (fieldValue === "ch") {
        resultedArray =
          value === "0"
            ? ["0"]
            : value === "notinpersonalreport"
            ? [...resultedArray, value].filter((item) => item !== "0")
            : resultedArray;
      } else {
        resultedArray = resultedArray.filter((item) => item !== value);
      }
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              selected: resultedArray,
            },
          },
        },
      };
    }
    case "radio":
    case "switch":
    case "select": {
      // radio button template
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              radio: {
                ...state.formDataValue[page][field].radio,
                [value]: fieldValue,
              },
            },
          },
        },
      };
    }
    case "selectarray": {
      const newSelection = Object.assign([], state.formDataValue[page][field], {
        [arrayIndex]: {
          ...state.formDataValue[page][field][arrayIndex],
          radio: {
            ...state.formDataValue[page][field][arrayIndex].radio,
            [value]: fieldValue,
          },
        },
      });

      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: newSelection,
          },
        },
      };
    }
    case "datetime": {
      let dateValue = String(fieldValue);
      let timestamp = Date.parse(fieldValue);

      if (isNaN(timestamp) == false) {
        dateValue = new Date(timestamp);
      }

      // set datetime picker value
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [action.location.field]: {
              ...state.formDataValue[page][field],
              dateTime: {
                ...state.formDataValue[page][field].dateTime,
                [value]: dateValue,
              },
            },
          },
        },
      };
    }
    case "textinput": {
      // set text value
      const textValues =
        fieldValue === undefined
          ? state.formDataValue[page][field].textValues.filter(
              (textValue) => textValue.value == value
            )
          : {
              ...state.formDataValue[page][field].textValues,
              [value]: fieldValue,
            };

      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: {
              ...state.formDataValue[page][field],
              textValues,
            },
          },
        },
      };
    }
    case "textinputarray": {
      return {
        ...state,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            [field]: Object.assign([], state.formDataValue[page][field], {
              [arrayIndex]: {
                ...state.formDataValue[page][field][arrayIndex],
                textValues: {
                  ...state.formDataValue[page][field][arrayIndex].textValues,
                  [value]: fieldValue,
                },
              },
            }),
          },
        },
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/updateData.js